// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/AddInvoiceAction/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_AddInvoiceAction($patient_id: numeric!) {
  vaxiom_txs(where: { tx_card: { patient_id: { _eq: $patient_id } } }) {
    id
  }
}

`